export default __webpack_public_path__ + "static/media/small_grid.ee2ed263.svg";